import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
/** @private Internal Usage. Only used for Dropdown component. Do not use this in your production. */
var OverrideContext = /*#__PURE__*/React.createContext(null);

/** @private Internal Usage. Only used for Dropdown component. Do not use this in your production. */
export var OverrideProvider = function OverrideProvider(_ref) {
  var children = _ref.children,
    restProps = _objectWithoutProperties(_ref, _excluded);
  var override = React.useContext(OverrideContext);
  var context = React.useMemo(function () {
    return _objectSpread(_objectSpread({}, override), restProps);
  }, [override, restProps.prefixCls,
  // restProps.expandIcon, Not mark as deps since this is a ReactNode
  restProps.mode, restProps.selectable
  // restProps.validator, Not mark as deps since this is a function
  ]);

  return /*#__PURE__*/_jsx(OverrideContext.Provider, {
    value: context,
    children: children
  });
};
export default OverrideContext;